import { render, staticRenderFns } from "./KeysTableTitle.vue?vue&type=template&id=03f231f2&scoped=true&"
import script from "./KeysTableTitle.vue?vue&type=script&lang=ts&"
export * from "./KeysTableTitle.vue?vue&type=script&lang=ts&"
import style0 from "./KeysTableTitle.vue?vue&type=style&index=0&id=03f231f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f231f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
